import { Theme } from '@mui/material'

const useStyles = {
  divider: (theme: Theme) => ({
    margin: theme.spacing(0, 1),
  }),
  accountListContainer: (theme: Theme) => ({
    maxHeight: '600px',
    overflowY: 'auto',
    margin: theme.spacing(0, -2),
  }),
  accountListRow: (theme: Theme) => ({
    padding: theme.spacing(1, 0),
  }),
  backdrop: (theme: Theme) => ({
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0,0,0,0.8)',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  }),
  backdropSearchContainer: (theme: Theme) => ({ width: `calc(100% - ${theme.spacing(8)})`, marginTop: theme.spacing(24), maxWidth: '930px' }),
  backdropCloseIconButton: (theme: Theme) => ({ position: 'absolute', right: 0, top: 0, color: theme.palette.common.white }),
  backdropCloseIcon: { fontSize: '60px' },
}
export default useStyles
